import { useEffect, useRef } from "react";
import * as echarts from "echarts/core";

/**
 * useEChart
 *
 * 職責：
 * - 將 echarts 掛載到指定的 DOM
 * - 自動處理 resize
 * - 在 option 改變時更新圖表
 *
 * 不負責：
 * - layout
 * - 資料處理
 * - option 組裝
 */
const useEChart = (domRef, option, theme = "light") => {
	const chartInstanceRef = useRef(null);
	const resizeFrameRef = useRef(null);

	// init / dispose
	useEffect(
		() => {
			if (!domRef.current) return;

			const chart = echarts.init(domRef.current, theme);
			chartInstanceRef.current = chart;

			// ResizeObserver（超輕 debounce）
			const observer = new ResizeObserver(() => {
				if (resizeFrameRef.current) {
					cancelAnimationFrame(resizeFrameRef.current);
				}

				resizeFrameRef.current = requestAnimationFrame(() => {
					chart.resize();
				});
			});

			observer.observe(domRef.current);

			return () => {
				observer.disconnect();
				chart.dispose();

				if (resizeFrameRef.current) {
					cancelAnimationFrame(resizeFrameRef.current);
				}
			};
		},
		// eslint-disable-next-line
		[domRef, theme],
	);

	useEffect(
		() => {
			if (!chartInstanceRef.current || !option) return;

			chartInstanceRef.current.setOption(option, true);
		},
		// eslint-disable-next-line
		[option],
	);

	return {
		getInstance: () => chartInstanceRef.current,
	};
};
export default useEChart;
